export default "__VITE_ASSET__04SbvGHF__"